import React from 'react';

const SocialShare = () => {
  return (
    <div className="social-share-container">
      {/* Compact Social Links */}
      <div className="flex justify-center space-x-3 mb-4">
        <a
          href="https://www.facebook.com/Carkeysolutions.net.au/?_rdr"
          target="_blank"
          rel="noopener noreferrer"
          className="w-10 h-10 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110"
          aria-label="Facebook"
        >
          <i className="fab fa-facebook-f"></i>
        </a>
        <a
          href="https://wa.me/61430168669"
          target="_blank"
          rel="noopener noreferrer"
          className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110"
          aria-label="WhatsApp"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
      </div>

    </div>
  );
};

export default SocialShare;
